import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRightToBracket } from '@fortawesome/free-solid-svg-icons';
import { ApplicationState } from '../store';
import { setAuthLoggedIn } from '../actions/AuthAction';
import App from '../App';
import './i18n'
import { useTranslation } from 'react-i18next';
import { naProvider, euProvider, enLocale, frLocale } from '../common/utils';

const Home = () => {
   const dispatch = useDispatch();
    const isLoggedIn = useSelector((state: ApplicationState) => state.Auth.isLoggedIn);
    //const isAuthenticated = useMemo(() => localStorage.getItem('authenticated') === 'true', []);
    const [takeToApp, setTakeToApp] = useState(false);
    const [loginType, setLoginType] = useState(null || '');
    const { t, i18n } = useTranslation();

    //const loginTypeMemo = useMemo(() => {
    //    var st = localStorage.getItem('loginType');
    //    if (st !== null) {
    //        console.log('inside');
    //        if (st === naProvider) {
    //            i18n.changeLanguage(enLocale);
    //        } else {
    //            i18n.changeLanguage(frLocale);
    //        }
    //        setTakeToApp(true);
    //    }
    //    //
    //    console.log(st);
    //    return st;
    //}, [setTakeToApp])

    useEffect(() => {
        var st = localStorage.getItem('loginType');
        if (st !== null) {
            if (st === naProvider) {
                i18n.changeLanguage(enLocale);
            } else {
                i18n.changeLanguage(frLocale);
            }
            if (!takeToApp) {
                setTakeToApp(true);
            }
        }
        else {
            console.log(takeToApp);
        }
    }, [setTakeToApp])

    const onLoginChooseHandler = (typeOfLogin: string) => {
        localStorage.setItem('loginType', typeOfLogin);
        console.log(loginType);
        //if (loginType === null || loginType === '') {
        //    setLoginType(typeOfLogin);
        //}
        if (typeOfLogin === naProvider) {
            i18n.changeLanguage(enLocale);
        } else {
            i18n.changeLanguage(frLocale);
        }
        
        dispatch(setAuthLoggedIn(typeOfLogin, true));
        setTakeToApp(true);
    }

    const noLoginChoosen = () => {
        return (
            <React.Fragment>
                <div className="row mb-1 alert alert-primary p-5">
                    <div className="col text-center">
                        <h3>Welcome!!! to <span className="text-danger font-weight-bold">Store Dispatch Portal</span></h3>
                        <h3>Please choose your login below</h3>
                    </div>
                </div>
                <div className="row alert alert-primary text-center">
                    <div className="d-flex flex-row justify-content-center col-md-12 col-xs-12">
                        <div className="col-md-5 col-xs-5 w-50 border border-3 border-primary rounded p-5 m-2 bg-light">
                            <a href="#" onClick={() => onLoginChooseHandler(euProvider)}>
                                <FontAwesomeIcon icon={faRightToBracket} size="2x" className="text-primary" />
                            </a>
                            <br />
                            Europe Users
                        </div>
                        <div className="col-md-5 col-xs-5 w-50 border border-3 border-primary rounded p-5 m-2 bg-light">
                            <a href="#" onClick={() => onLoginChooseHandler(naProvider)}>
                                <FontAwesomeIcon icon={faRightToBracket} size="2x" className="text-primary" />
                            </a>
                            <br />
                            NA Users
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }

    const loginChoosen = () => {
        return <App />
    }

    if (takeToApp) {
        return loginChoosen();
    }
    else {
        return noLoginChoosen();
    }
};

export default Home;
